<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="subjectType" v-for="item of subjectTypeList" :key="item.id">
        <p class="subjectTypeName">{{ item.name }}</p>
        <p class="introduce">{{ item.introduce }}</p>
        <el-button style="width: 137px" type="primary" @click="choose(item)">选择</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      subjectTypeList: [
        {
          name: '个体商户',
          introduce: '营业执照上的主题类型一般为个体户、个体工商户、个体经营',
          id: 0,
          value:'SUBJECT_TYPE_INDIVIDUAL',
        },
        {
          name: '企业',
          introduce: '营业执照上的主体类型一般为有限公司、有限责任公司',
          id: 1,
          value:'SUBJECT_TYPE_ENTERPRISE',
        },
        {
          name: '党、政机关及事业单位',
          introduce:
            '包括国内各级、各类政府机构、事业单位等。如：公安、党团、司法、交通、旅游、工商税务、市政、医疗、教育、学校等机构',
          id: 2,
          value:'SUBJECT_TYPE_INSTITUTIONS',
        },
        {
          name: '其他组织',
          introduce:
            '不属于企业、政府/事业单位的组织机构，如社会团体、民办非企业、基金会。要求机构已办理组织机构代码证',
          id: 3,
          value:'SUBJECT_TYPE_OTHERS',
        },
      ],
    };
  },

  watch: {},
  computed: {
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
  },
  methods: {
    choose(item) {
      this.$router.push({
        path: '/merchants/addMerchants',
        query: {
          subjectName: item.value,
          id: item.id,
          type: 'add',
          merchantId: this.merchantId,
          facilitatorName: this.facilitatorName,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.box {
  display: flex;
  .subjectType {
    width: 322px;
    height: 216px;
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-right: 16px;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 36px 10px 19px 10px;
    background-color: white;
    .subjectTypeName {
      margin-bottom: 13px;
    }
    .introduce {
      color: #999;
      font-weight: normal;
    }
  }
}
</style>
